import { render, staticRenderFns } from "./mange.vue?vue&type=template&id=6340ad30"
import script from "./mange.vue?vue&type=script&lang=js"
export * from "./mange.vue?vue&type=script&lang=js"
import style0 from "./mange.vue?vue&type=style&index=0&id=6340ad30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports